<div class="modal-header d-flex justify-content-between">
  <h4 class="modal-title" id="modal-basic-title">{{lgScreenShot.name}}
    <i *ngIf="lgScreenShot.path" class="fas fa-file-export clickable ml-1 mb-2" ngbTooltip="Export Image to File Management"  (click)="exportImage(lgScreenShot)"></i>
  </h4>
  <div >
  <!-- <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button> -->
  <div class="d-flex align-items-center mt-2" >
    <div *ngIf="lgScreenShot.path">
     <i class="fas fa-download clickable mx-2" (click)='donwloaURI(lgScreenShot.path)' ngbTooltip="Download Image" ></i>
    </div>
    <div>
      <i class="fa fa-times clickable mx-2" ngbTooltip="Close" aria-hidden="true"  (click)="activeModal.dismiss('Cross click')"></i>
  </div>
  </div>
</div>
</div>
<div class="modal-body">
  <div class="loader" *ngIf="!lgScreenShot.path"></div>
  <div class="nav-arrow">
    <span> <i class="fas fa-chevron-left float-left left" (click)="changeScreenshotimg(lgScreenShot.index -1 )"
        *ngIf="lgScreenShot.index > 0"></i> 
    </span>
    <span> <i class="fas fa-chevron-right float-right right" (click)="changeScreenshotimg(lgScreenShot.index + 1)"
        *ngIf="lgScreenShot.index < (lgScreenShot.length - 1)"></i>
    </span>
  </div>
  <img class="img-fluid" [attr.src]="lgScreenShot.path"  />
</div>
